var _defs, _path, _path2, _path3, _path4, _path5, _path6, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRiseCrm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 378.46 110.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#00abc5;}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "233.02 49.85 208.71 85.96 217.06 99.17 239.06 103.97 254.05 98.36 264.09 83.45 262.47 64.1 249.47 52.14 233.02 49.85"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M300.99,102.19l-11.52-16.2c-1.3,.14-2.59,.22-4.03,.22h-13.54v15.99h-5.33V51.78h18.87c12.82,0,20.59,6.48,20.59,17.28,0,7.92-4.18,13.47-11.52,15.84l12.31,17.28h-5.83Zm-.29-33.12c0-8.06-5.33-12.67-15.41-12.67h-13.39v25.27h13.39c10.08,0,15.41-4.68,15.41-12.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M370.97,51.78v50.4h-5.11V61.86l-19.8,33.92h-2.52l-19.8-33.7v40.11h-5.11V51.78h4.39l21.89,37.37,21.67-37.37h4.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.62,54.01h-8.69v14.96H10V12.66h25.74c15.37,0,25.02,7.96,25.02,20.84,0,8.29-4.02,14.4-11.02,17.78l12.15,17.7h-17.06l-10.22-14.96Zm.16-28.8h-8.85v16.49h8.85c6.6,0,9.89-3.06,9.89-8.21s-3.3-8.29-9.89-8.29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.28,12.66h15.93v56.31h-15.93V12.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.36,63.91l5.23-11.75c4.99,3.3,12.07,5.55,18.58,5.55s9.17-1.85,9.17-4.59c0-8.93-32.02-2.41-32.02-23.33,0-10.06,8.21-18.26,24.94-18.26,7.32,0,14.88,1.69,20.43,4.91l-4.91,11.83c-5.39-2.9-10.7-4.34-15.61-4.34-6.68,0-9.09,2.25-9.09,5.07,0,8.61,31.94,2.17,31.94,22.93,0,9.81-8.21,18.18-24.94,18.18-9.25,0-18.42-2.49-23.73-6.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.43,56.67l-8.27,12.31h-36.06V12.66h44.17v12.31h-28.4v9.49h25.02v11.91h-25.02v10.3h28.56Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M210.34,76.99c0-14.76,11.23-25.63,26.43-25.63,7.34,0,13.97,2.45,18.43,7.34l-3.38,3.38c-4.1-4.18-9.15-5.98-14.91-5.98-12.17,0-21.31,8.93-21.31,20.88s9.15,20.88,21.31,20.88c5.76,0,10.8-1.8,14.91-6.05l3.38,3.38c-4.46,4.9-11.09,7.42-18.51,7.42-15.12,0-26.35-10.87-26.35-25.63Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiseCrm);
export default __webpack_public_path__ + "static/media/riseCrm.431d68744a08206607b30e8ce8adc74a.svg";
export { ForwardRef as ReactComponent };